// extracted by mini-css-extract-plugin
export default {"modalContent":"AcceptRejectModal_modalContent__Pw1F7"};